import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPassword = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState('');

  return (
    <div className="min-h-screen bg-background">
      {/* Simple Logo Header */}
      <div className="border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <Link to="/user-login" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/assets/images/90A19BF4-3446-4543-87E4-2148054C81C1-1768952058269.jpeg" alt="OfferSense Logo" className="w-10 h-10 object-contain" />
            <span className="text-xl font-semibold">
              <span className="text-[#2C3E5F]">OfferSense</span>
              <span className="text-[#5DBFB3]">.Ai</span>
            </span>
          </Link>
        </div>
      </div>

      <main className="main-content">
        <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-md">
            <div className="bg-card rounded-xl shadow-elevation-lg p-6 md:p-8 lg:p-10 border border-border">
              {!emailSent ? (
                <>
                  <div className="text-center mb-6 md:mb-8">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon name="Lock" size={32} color="var(--color-primary)" />
                    </div>
                    <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                      Forgot Password?
                    </h1>
                    <p className="text-sm md:text-base text-muted-foreground">
                      No worries! Enter your email address and we'll send you a secure link to reset your password.
                    </p>
                  </div>

                  <ForgotPasswordForm 
                    onSuccess={(submittedEmail) => {
                      setEmail(submittedEmail);
                      setEmailSent(true);
                    }} 
                  />

                  <div className="mt-6 text-center">
                    <Link 
                      to="/user-login" 
                      className="text-sm text-primary hover:text-primary/80 transition-colors inline-flex items-center gap-2"
                    >
                      <Icon name="ArrowLeft" size={16} />
                      Back to Login
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center mb-6 md:mb-8">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-success/10 flex items-center justify-center">
                      <Icon name="Mail" size={32} color="#10b981" />
                    </div>
                    <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                      Check Your Email
                    </h1>
                    <p className="text-sm md:text-base text-muted-foreground mb-4">
                      We've sent a password reset link to:
                    </p>
                    <p className="text-base font-semibold text-foreground mb-4">
                      {email}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      Click the link in the email to reset your password. The link will expire in 1 hour.
                    </p>
                  </div>

                  <div className="space-y-4">
                    <div className="p-4 bg-muted/50 rounded-lg border border-border">
                      <p className="text-sm text-muted-foreground mb-2">
                        <strong className="text-foreground">Didn't receive the email?</strong>
                      </p>
                      <ul className="text-xs text-muted-foreground space-y-1 ml-4 list-disc">
                        <li>Check your spam or junk folder</li>
                        <li>Make sure you entered the correct email address</li>
                        <li>Wait a few minutes for the email to arrive</li>
                      </ul>
                    </div>

                    <button
                      onClick={() => setEmailSent(false)}
                      className="w-full py-3 px-4 bg-muted hover:bg-muted/80 text-foreground rounded-lg transition-colors text-sm font-medium"
                    >
                      Try Another Email
                    </button>

                    <Link 
                      to="/user-login" 
                      className="block text-center text-sm text-primary hover:text-primary/80 transition-colors"
                    >
                      Back to Login
                    </Link>
                  </div>
                </>
              )}
            </div>

            <div className="mt-6 md:mt-8 text-center">
              <p className="text-xs md:text-sm text-muted-foreground">
                Need help? Contact our support team
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} OfferSense. All rights reserved.
            </p>
            <div className="flex items-center gap-4 md:gap-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ForgotPassword;